<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@forgetPassword">Forget Password</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <div i18n="@@forgetPasswordMessageNeededEmail" class="text-center dialog-sub-title mat-caption">We need your registered e-mail address to send you a reset password link.</div>

  <form [formGroup]="forgetPasswordForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label i18n="@@emailLabel">Email</mat-label>
      <input  data-testid="forget_password_email" matInput id="email" placeholder="Email" i18n-placeholder="@@emailPlaceholder"  name="email" formControlName="email" required />
      <mat-error>
        @if (forgetPasswordForm.get('email')?.hasError('required') && forgetPasswordForm.get('email')?.touched) {
          <span i18n="@@inValidRequiredField">This field is required</span>
        }
        @if (forgetPasswordForm.get('email')?.hasError('email') && forgetPasswordForm.get('email')?.touched) {
          <span i18n="@@inValidEmail">Please enter a valid email</span>
        }
      </mat-error>
    </mat-form-field>

    <mat-dialog-actions>
      <button i18n="@@resetPassword" data-testid="forget_password_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Reset Password</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>